import { Controller } from "@hotwired/stimulus"

// Manages the age verification popup.
// Reads the required age from a data attribute and stores confirmation in a cookie.
export default class extends Controller {
  static values = { age: Number }

  connect() {
    if (this.#alreadyConfirmed()) {
      this.element.remove()
    } else {
      // Prevent body scroll while popup is visible
      document.body.style.overflow = "hidden"
    }
  }

  confirm() {
    this.#setCookie("age_confirmed", "true", 30)
    document.body.style.overflow = ""
    this.element.remove()
  }

  decline() {
    window.location.href = "https://www.google.com"
  }

  // ---- private helpers ----

  #alreadyConfirmed() {
    return document.cookie.split("; ").some(c => c.startsWith("age_confirmed="))
  }

  #setCookie(name, value, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString()
    document.cookie = `${name}=${value}; expires=${expires}; path=/; SameSite=Lax`
  }
}
